/*
 * Deep link landing.
 *
 * Arriving at /#story from another template (the cart, a policy page) lands
 * near the top of the home page instead of at the section. The browser makes
 * the jump while the page is still settling: the full height hero, the video
 * metadata and the section media all resolve after that first attempt, the
 * target moves several thousand pixels, and the scroll is left stranded.
 * Measured on the live store: scrollY 63 where the target was 2226.
 *
 * Re-applying the jump once the load event has fired puts it right. In page
 * clicks are untouched, since no load event fires for a same document jump,
 * so the CSS smooth scroll still owns those.
 *
 * The scroll is instant rather than smooth: this is an arrival, not a
 * navigation the visitor watches, and it also keeps the behaviour honest
 * under prefers-reduced-motion.
 */
(function () {
  'use strict';

  // Not about deep links. iOS Safari only applies :active to a tap when the
  // page has a touch listener, and this is the one script every page loads,
  // through the header. Without it the press states in peanut.css never show
  // on an iPhone. It sat in peanut-nav-active.js for a day, which only the
  // home page loads, so the product page had no press states at all. Passive,
  // and it does nothing. It has to come before the early return below.
  document.addEventListener('touchstart', function () {}, { passive: true });

  if (!window.location.hash || window.location.hash.length < 2) return;

  var id = window.location.hash.slice(1);
  var userScrolled = false;

  // Never fight the visitor. If they have already started moving the page
  // themselves, leave it alone.
  ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, function () { userScrolled = true; }, {
      passive: true,
      once: true
    });
  });

  function settle() {
    if (userScrolled) return;

    var el = document.getElementById(id);
    if (!el) return;
    // A target inside a dialog is not a place on the page. The signup offer's
    // form comes back as #peanut-offer-form after a post, and the dialog that
    // holds it opens over the page instead.
    if (el.closest && el.closest('dialog')) return;

    // Honour the same offset anchor jumps use, so this lands identically to a
    // click made on the page itself.
    var pad = parseFloat(
      getComputedStyle(document.documentElement).scrollPaddingTop
    ) || 0;
    var target = el.getBoundingClientRect().top + window.scrollY - pad;

    if (Math.abs(window.scrollY - target) < 4) return;

    // 'instant', not 'auto'. 'auto' defers to the CSS scroll-behavior, which
    // this theme sets to smooth, so the arrival would animate across the whole
    // page and the follow up pass below would keep restarting it mid flight.
    window.scrollTo({ top: target, behavior: 'instant' });
  }

  window.addEventListener('load', function () {
    settle();
    // A second pass catches late shifts from fonts and video metadata.
    setTimeout(settle, 250);
  });
})();
